import React from 'react';
import ReactDOM from 'react-dom/client';
import SummaryCard from './SummaryCard';

let reactRoot = null;

export function generateReport(id) {
    // fetch(`http://localhost:5275/redlines/${id}/report`, {
    if (id == null) {

    }
    else {
        injectSummaryCard(); // Ensure the summary card is present
        updateSummaryCard(null); // Display Loading
        fetch(`https://portal.boom-h2-pipelines.com/api/redlines/${id}/reportDetailed`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                updateSummaryCard(data)
            })
            .catch(error => {
                console.error("Error sending geometry:", error);
            });
    }
}

export function injectSummaryCard() {
  if (document.getElementById("pipeline-feature-tree")) {
    document.getElementById("pipeline-feature-tree").style.display = "block";
    document.getElementById("summary-card").style.display = "block";
    return;
  }

  const reactMount = document.createElement("div");
  reactMount.id = "pipeline-feature-tree";
  reactMount.style.position = "absolute"; // Important!
  reactMount.style.top = "20px";
  reactMount.style.left = "20px";
  reactMount.style.zIndex = "1000"; // Ensure it's above the map

  document.getElementById("map").appendChild(reactMount);
}

export function updateSummaryCard(data) {
    const mountNode = document.getElementById("pipeline-feature-tree");
    if (!mountNode) return;

    if (!reactRoot) {
        reactRoot = ReactDOM.createRoot(mountNode);
    }

    reactRoot.render(<SummaryCard data={data} />);
}

export function resetSummaryCard() {
    const helpText = document.getElementById('help-text');
    if (helpText) helpText.style.display = 'block';

    if (reactRoot) {
        reactRoot.render(<p style={{ textAlign: 'center', fontStyle: 'italic' }}>No route selected yet</p>);
    }
}

export function createRedline(geometry) {
    const jsonGeom = geometry.toJSON();
    let coords;

    switch (geometry.type) {
        case "polygon":
            coords = jsonGeom.rings;
            break;
        case "polyline":
            coords = jsonGeom.paths;
            break;
        case "point":
            coords = { x: jsonGeom.x, y: jsonGeom.y };
            break;
        default:
            console.error("Unsupported geometry type");
            return Promise.resolve(null);
    }

    // return fetch("http://localhost:5275/redlines", {
    return fetch("https://portal.boom-h2-pipelines.com/api/redlines", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            type: geometry.type,
            coordinates: coords
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log("API response:", data);
            return data;
        })
        .catch(error => {
            console.error("Error sending geometry:", error);
            return null;
        });
}

export function updateRedline(id, geometry) {
    const jsonGeom = geometry.toJSON();
    let coords;

    switch (geometry.type) {
        case "polygon":
            coords = jsonGeom.rings;
            break;
        case "polyline":
            coords = jsonGeom.paths;
            break;
        case "point":
            coords = { x: jsonGeom.x, y: jsonGeom.y };
            break;
        default:
            console.error("Unsupported geometry type");
            return Promise.resolve(null);
    }

    // return fetch("http://localhost:5275/redlines", {
    return fetch(`https://portal.boom-h2-pipelines.com/api/redlines/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            type: geometry.type,
            coordinates: coords
        })
    })
        .then(response => response.json())
        .then(data => {
            // console.log("API response:", data);
            return data;
        })
        .catch(error => {
            console.error("Error sending geometry:", error);
            return null;
        });
}

export function deleteRedline(id) {
    fetch(`https://portal.boom-h2-pipelines.com/api/redlines/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
            //,'Authorization': 'Bearer YOUR_ACCESS_TOKEN' // if needed
        }
    }).then(respose => {
        resetSummaryCard();
    });
}

export function getSymbolForType(type) {
    if (type == "polyline" || type === "LineString" || type === "MultiLineString") {
        return {
            type: "simple-line",
            color: "red",
            width: 2,
            style: "dash" // Options: "solid", "short-dot", "short-dash", "dash", "dash-dot", etc.
        };
    }
    if (type === "Polygon") {
        return {
            type: "simple-fill",
            color: "rgba(0, 0, 255, 0.2)",
            outline: {
                color: "blue",
                width: 1
            }
        };
    }
    return {
        type: "simple-marker",
        color: "blue"
    };
}